// extracted by mini-css-extract-plugin
export default {"Emoji":"bba_a bhb_i bhb_q bhb_j"};